import template from './footer.html';


const FooterComponent = {
    restrict: 'E',
    templateUrl: template,
};

export {FooterComponent};



// WEBPACK FOOTER //
// ./app/components/common/footer/footer.component.js